import React from "react";
import { useNavigate } from "react-router-dom";
import "./BlogStyles.css";

const blogList = [
  {
    id: 1,
    title: "Love Astrology",
    shortDesc: "Your cosmic guide to relationships and soul connections.",
    image: require("../assets/zodiac/Aquarius.jpg"),
    link: "/blogs/love-astrology-blog",
  },
  {
    id: 2,
    title: "Career Astrology",
    shortDesc: "Discover your ideal profession through your birth chart.",
    image: require("../assets/zodiac/Virgo.jpg"),
    link: "/blogs/career-astrology-blog",
  },
  {
    id: 3,
    title: "12 Astrology Houses Explained",
    shortDesc: "Decode every house in your horoscope with ease.",
    image: require("../assets/zodiac/Leo.jpg"),
    link: "/blogs/blog3",
  },
];

function BlogPage() {
  const navigate = useNavigate();

  return (
    <div className="blog-container">
      <h1>Astrology Blogs</h1>
      <div className="blog-grid">
        {blogList.map((blog) => (
          <div key={blog.id} className="blog-card" onClick={() => navigate(blog.link)}>
           
            <img src={blog.image} alt={blog.title} />
            <h3>{blog.title}</h3>
            <p>{blog.shortDesc}</p>
            <button>Read More</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogPage;
